import {
  Users,
  UserCheck,
  BookOpen,
  Layers
} from "lucide-react";

const StudentStats = ({ students = [] }) => {
  const totalStudents = students.length;

  const activeStudents = students.filter(
    s => s.CurrentLevel && s.CurrentLevel !== "Inactive"
  ).length;

  const courses = new Set(students.map(s => s.CourseName)).size;
  const batches = new Set(students.map(s => s.BatchName)).size;

  const stats = [
    {
      label: "Total Students",
      value: totalStudents,
      icon: <Users size={22} />
    },
    {
      label: "Active Students",
      value: activeStudents,
      icon: <UserCheck size={22} />
    },
    {
      label: "Courses",
      value: courses,
      icon: <BookOpen size={22} />
    },
    {
      label: "Batches",
      value: batches,
      icon: <Layers size={22} />
    },
  ];

  return (
    <div className="student-stats">
      {stats.map((s, i) => (
        <div key={i} className="stat-card">
          <div className="stat-icon">
            {s.icon}
          </div>

          <div className="stat-info">
            <span className="stat-label">{s.label}</span>
            <strong className="stat-value">{s.value}</strong>
          </div>
        </div>
      ))}
    </div>
  );
};

export default StudentStats;
